import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Box, Button, Stack, styled, Typography } from '@mui/material';
export const Content = styled(Stack)(({ theme }) => ({
    gap: theme.spacing(5),
    width: '100%',
    maxWidth: '46rem',
    paddingBottom: theme.spacing(36),
    overflow: 'auto',
    [theme.breakpoints.up('sm')]: {
        margin: '0 auto',
        paddingBottom: 0,
    },
}));
export const QuestionWrapper = styled('section')(({ theme }) => ({
    paddingBottom: '6rem',
    width: '100%',
    ['p:has(img)']: {
        textAlign: 'center',
    },
    ['img']: {
        width: '50%',
    },
    [theme.breakpoints.up('sm')]: {
        paddingBottom: 0,
        ['p:has(img)']: {
            textAlign: 'initial',
        },
        ['img']: {
            width: 'auto',
        },
    },
}));
const layoutStyles = {
    grid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 2,
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        gap: '0.5rem',
    },
};
export const AnswersWrapper = ({ contentDisplay, ...props }) => {
    const componentStyling = contentDisplay ? layoutStyles[contentDisplay] : {};
    return _jsx(Box, { sx: (theme) => ({ marginBottom: theme.spacing(4) }), ...componentStyling, ...props });
};
export const QuestionTitle = styled(Typography)(({ theme }) => ({
    fontSize: theme.spacing(6),
    lineHeight: theme.spacing(7),
    marginBottom: theme.spacing(4),
}));
export const ButtonWrapper = styled(Button)(({ theme }) => ({
    margin: '0 1.5rem',
    order: 2,
    [theme.breakpoints.up('md')]: {
        margin: 0,
        order: 1,
    },
}));
//# sourceMappingURL=data:application/json;base64,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